import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vi from '@src/lang/vi'

Vue.use(VueI18n)
const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    time: {
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  vi: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    time: {
      hour: 'numeric',
      minute: 'numeric',
    },
  },
}
const messages = { vi }
const i18n = new VueI18n({
  locale: 'vi', // set locale
  messages,
  fallbackLocale: 'vi',
  dateTimeFormats,
})
export default i18n
const loadedLanguages = ['vi']
export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: "lang-[request]" */ `@src/lang/${lang}`
  ).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  })
}

function setI18nLanguage(lang) {
  i18n.locale = lang
  try {
    window.localStorage.setItem('locale', lang)
  } catch (error) {
    console.log(error)
  }
  document.querySelector('html').setAttribute('lang', lang)

  return lang
}

export function checkCurrentLang() {
  try {
    const currentLang = window.localStorage.getItem('locale') || 'vi'
    loadLanguageAsync(currentLang)
  } catch (error) {
    console.log(error)
  }
}
